import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { shouldDisableCopilot } from 'owa-copilot-settings-store/lib/utils/shouldDisableCopilot';
import hasM365CopilotLicense from './hasM365CopilotLicense';
import { getIsCopilotUIDisabled } from 'owa-mail-copilot-settings/lib/selectors/getIsCopilotUIDisabled';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Checks user preferences on displaying copilot and then checks if user has a copilot license
 */
export function isCopilotLicensedAndEnabledUser(mailboxInfoParam?: MailboxInfo): boolean {
    const mailboxInfo = mailboxInfoParam ?? getGlobalSettingsAccountMailboxInfo();

    if (shouldDisableCopilot(mailboxInfo) || getIsCopilotUIDisabled(mailboxInfo)) {
        return false;
    }
    return hasM365CopilotLicense(mailboxInfo);
}
